import { render, staticRenderFns } from "./BankAccountSetup.vue?vue&type=template&id=f0f1634c&scoped=true&"
import script from "./BankAccountSetup.vue?vue&type=script&lang=ts&"
export * from "./BankAccountSetup.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccountSetup.vue?vue&type=style&index=0&id=f0f1634c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f1634c",
  null
  
)

export default component.exports